export const trustPilotTop = {
    href: "#",
    imageUrl: "https://cdn.shopify.com/s/files/1/0598/3712/0675/files/Group_60.png",
    visibility: false,
    position: 1,
    openNewTab: false
}

export const trustPilotBottom = {
    href: "#",
    imageUrl: "https://cdn.shopify.com/s/files/1/0598/3712/0675/files/Group_108.png?v=1660142729",
    visibility: false,
    position: 1,
    openNewTab: true
}

export const trustPilotCategory = 
{
    href: "#",
    imageUrl: "https://cdn.shopify.com/s/files/1/0618/3482/1855/files/Trust_Pilot_Header.png",
}

export const trustPilotCustomSetting = 
{
    //Custom in FOOTER
    footer:false,
    //Custom in HEADER
    header: 
    {
        desktop: false,
        mobile: false
    }

}